import React, { useState } from 'react';
import { View } from 'react-native';
import { useColors } from '../constants/useColors';
import { Text } from './Themed';

type ProgressBarProps = { 
    hide_labels?:boolean, 
    height?:number, 
    max_value:number, 
    current_value:number, 
    background_color:string, 
    fill_color:string, 
    max_label?:string, 
    val_color?:string,
    val_label?:string,
    val_format?: {
        loc: 'front'|'back',
        label: string
    }
}

const ProgressBar = ({ max_value, val_format, val_color, current_value, height, hide_labels, background_color, fill_color, max_label, val_label }:ProgressBarProps) => {
    const Colors = useColors();
    const [ progressSize, setProgressSize ] = useState({ x:0, y:0, width:0, height:0 })

    const getProgressWidth = (current_value:number) => {
        let progress = current_value / max_value
        if(progress > 1){ progress = 1 }
        return progressSize.width * progress
    }


    return (
        <View style={{ padding:10 }}>
            <View style={{ flexDirection:'row' }}>
                <View style={{ flex:1, padding:height??8, backgroundColor:background_color??Colors.views.header, borderRadius:4 }} onLayout={(ev) => {
                const { x, y, width, height } = ev.nativeEvent.layout
                setProgressSize({ x, y, width, height })
            }}>
                    <View style={{ borderRadius:4, position:'absolute', backgroundColor:fill_color??Colors.text.h1, left:0, top:0, width:getProgressWidth(current_value??0), height:progressSize.height }} />
                </View>
            </View>
            {!hide_labels ?
            <View style={{ flexDirection:'row', justifyContent:'space-between', alignItems:'center', marginTop:10}}>
                <Text size={12} color={val_color ?? Colors.text.h1}>{val_label?`${val_label}: `:''}{val_format?.loc=='front'?val_format.label:''}{current_value?.toFixed(2)}{val_format?.loc=='back'?val_format.label:''}</Text>
                <Text size={12} color={Colors.text.h1}>{max_label?`${max_label}: `:''}{val_format?.loc=='front'?val_format.label:''}{max_value?.toFixed(2)}{val_format?.loc=='back'?val_format.label:''}</Text>
            </View>
            :<></>}
        </View>
        
    )
}

export default ProgressBar